import React, { useState, useRef } from "react";
import About from "../assests/qac7.jpg";
import img106 from "../assests/IMG_2442.jpeg";
import emailjs from "@emailjs/browser";
import { Redirect } from "react-router";

// Import Form from '@fillout/react'

const MemberRegistration = () => {
  const form = useRef();
  const [formData, setFormData] = useState({
    title: "Mr", //{/**radio Mr,Mrs,Miss,Master*/}
    surname: "", //{/**text */}
    name: "", //{/**text */}
    dateOfBirth: "", //{/**date */}
    identityNumber: "", //{/**identityNumber*/}
    message: "", //{/**text */}
    email: "", //{/**text email */}
    gender: "",
    contactNumber: "", //{/**numbers */}
    occupation: "", //{/**selection */}
    personalCoaching: "No", //{/** radio yes,No,Later stage */}
    licenseNumber: "", //{/**number */}
    interest: ["roadRunning"], //{/** checkbox:crossfit,cycling,hiking,road running,swimming,trail running, walking, yoga,others */}
    school: "", //{/**text */}
    grade: "", //{/**number */}
    nextOfKin: "", //{/**text */}
    emergencyContact: "", //{/**number */}
    medicalAidScheme: "", //{/**text */}
    medicalAidNumber: "", //{/**number */}
    membershipFees: "senior", //{/**radio:  Junior:19y or younger 470new/350renewal,senior:20-39 800new/600renewal,Veteran:40-49 800new/600renewal,master:50-59 800new/600renewal,Grand master:60-69 470new/350renewal,Couple:2 memebers 1400new/1100renewal, family-25% discount fro 3 or more family memebers if they join at the same time*/}
  });

  const onChangeHandler = (event) => {
    console.log(event);
    let copy = { ...formData };
    if (event.target.name === "interest") {
      if (event.target.checked) {
        copy.interest.push(event.target.value);
      } else {
        copy.interest = copy.interest.filter((el) => el !== event.target.value);
      }
      setFormData(copy);
    } else {
      setFormData(() => ({
        ...formData,
        [event.target.name]: event.target.value,
      }));
    }
  };

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm("service_kb3r1ir", "template_5dpqcah", form.current, {
        publicKey: "dPYa_97xXrg5tnp9Y",
      })
      .then(
        () => {
          console.log("SUCCESS!");
          alert(
            "Your form has been submitted. You will be redirected to our online payment portal."
          );
          window.location.href = "https://pay.yoco.com/qhubeka-ac";
        },
        (error) => {
          console.log("FAILED...", error.text);
          alert(
            "Message NOT sent. Please email us on admin@qhubekaac.co.za for further assistance"
          );
        }
      );
  };

  const onSubmitHandler = async (event) => {
    const {
      title,
      surname,
      username,
      dateOfBirth,
      identityNumber,
      address,
      email,
      gender,
      contactNumber,
      occupation,
      personalCoaching,
      licenseNumber,
      interest,
      school,
      grade,
      nextOfKin,
      emergencyContact,
      medicalAidScheme,
      medicalAidNumber,
      membershipFees,
    } = formData;

    event.preventDefault();
    const options = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        title,
        surname,
        username,
        dateOfBirth,
        identityNumber,
        address,
        email,
        gender,
        contactNumber,
        occupation,
        personalCoaching,
        licenseNumber,
        interest,
        school,
        grade,
        nextOfKin,
        emergencyContact,
        medicalAidScheme,
        medicalAidNumber,
        membershipFees,
      }),
    };
    // const res= await fetch('https://qhubeka-ac-default-rtdb.firebaseio.com/formData.json',options);
    // console.log(res);
    // if(res){
    //   alert("Data Stored")
    // }else{
    //   alert("Error ocurred")
    // }
  };

  return (
    <div
      name="MemberRegistration"
      className="grid col-span-1 w-full h-full bg-white text-white font-bold"
    >
      <div className=" grid md:grid-cols-2 grid-col-span-1 gap-4 pt-36 md:pt-0 bg-red-700  w-full md:pr-7 ">
        {/** Grid Item */}
        <div className="    container rounded-md flex justify-center items-center mx-auto bg-cover bg-center">
          {/**Hover effect */}

          <div className="grid md:grid-cols-1">
            <div className="md:pt-20 px-10 text-4xl  text-white font-bold text-center">
              <h1>Welcome to the club! Let’s make it official. </h1>
            </div>
            <div className="md:pt-5 px-10  text-white font-bold text-center">
              <h1>
                Simply complete the form below, and we’ll be in touch soon.
              </h1>
            </div>
          </div>
        </div>
        {/* bottom image */}
        <div className="w-full py-2  contain px-4 md:px-0 rounded-2xl md:pt-32 bg-center bg-cover md:bg-top">
          <img
            src={img106}
            className="shadow-2xl hover:scale-110 duration-1000 shadow-black w-full h-full bg-contain rounded-2xl object-contain"
            alt="Welcome Image"
            loading="lazy"
          />
        </div>
      </div>

      <div className="pt-10 px-10 text-sm text-center">
        <h1 className="   rounded-2xl bg-white shadow-2xl shadow-black text-red-700">
          Disclaimer: Membership fee does not incude club kit!
        </h1>
      </div>

      <div className=" grid md:grid-cols-3 grid-cols-1 gap-7 py-7 px-4">
        {/** Grid Item */}

        <div className=" bg-[#001ea1] py-4 shadow-lg shadow-[#0f0f0f] group container rounded-md  ">
          {/**Hover effect */}
          <div className="">
            <div className="">
              <span className="text-4xl  items-center flex justify-center font-bold first-letter text-white tracking-wider">
                Junior
              </span>
            </div>
            <span className="text- pt-5  items-center flex justify-center text-center font-bold first-letter text-white tracking-wider">
              19 years and younger
            </span>
            <span className="text- pt-5  items-center flex justify-center text-center font-bold first-letter text-white tracking-wider">
              R470
            </span>
          </div>
        </div>

        <div className=" bg-red-700 shadow-lg shadow-[#0f0f0f] py-4 group container rounded-md flex justify-center items-center mx-auto ">
          {/**Hover effect */}
          <div className="">
            <div className="">
              <span className="text-4xl  items-center flex justify-center font-bold first-letter text-white tracking-wider">
                Senior
              </span>
            </div>
            <span className="text- pt-5  items-center flex text-center justify-center font-bold first-letter text-white tracking-wider">
              20 to 39 years
            </span>
            <span className="text- pt-5  items-center flex justify-center text-center font-bold first-letter text-white tracking-wider">
              R800
            </span>
          </div>
        </div>

        <div className=" bg-white shadow-lg py-4 shadow-[#0f0f0f] group container rounded-md flex justify-center items-center mx-auto">
          {/**Hover effect */}
          <div className="">
            <div className="">
              <span className="text-4xl text-[#001ea1] items-center flex justify-center font-bold first-letter  tracking-wider">
                Veteren
              </span>
            </div>
            <div>
              <span className="text- pt-5 text-[#001ea1] text-center items-center flex justify-center font-bold first-letter tracking-wider">
                40 to 49
              </span>
              <span className="text-[#001ea1] pt-5  items-center flex justify-center text-center font-bold first-letter  tracking-wider">
                R800
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className=" grid md:grid-cols-3 grid-cols-1 gap-7 pb-7 px-4">
        {/** Grid Item */}

        <div className=" bg-[#001ea1] py-4 shadow-lg shadow-[#0f0f0f] group container rounded-md  ">
          {/**Hover effect */}
          <div className="">
            <div className="">
              <span className="text-4xl  items-center flex justify-center font-bold first-letter text-white tracking-wider">
                Master
              </span>
            </div>
            <span className="text- pt-5  items-center flex justify-center text-center font-bold first-letter text-white tracking-wider">
              50 to 59 years
            </span>
            <span className="text- pt-5  items-center flex justify-center text-center font-bold first-letter text-white tracking-wider">
              R800
            </span>
          </div>
        </div>

        <div className=" bg-red-700 shadow-lg py-4 shadow-[#0f0f0f] group container rounded-md flex justify-center items-center mx-auto ">
          {/**Hover effect */}
          <div className="">
            <div className="">
              <span className="text-4xl  items-center flex justify-center font-bold first-letter text-white tracking-wider">
                Grandmaster
              </span>
            </div>
            <span className="text- pt-5  items-center flex text-center justify-center font-bold first-letter text-white tracking-wider">
              60+ years
            </span>
            <span className="text- pt-5  items-center flex justify-center text-center font-bold first-letter text-white tracking-wider">
              R470
            </span>
          </div>
        </div>

        <div className=" bg-white shadow-lg py-4 shadow-[#0f0f0f] group container rounded-md flex justify-center items-center mx-auto">
          {/**Hover effect */}
          <div className="">
            <div className="">
              <span className="text-4xl text-[#001ea1] items-center flex justify-center font-bold first-letter  tracking-wider">
                Couples
              </span>
            </div>
            <div>
              <span className="text- pt-5 text-[#001ea1] text-center items-center flex justify-center font-bold first-letter tracking-wider">
                2 px when joining at the same time
              </span>
              <span className="text-[#001ea1] pt-5  items-center flex justify-center text-center font-bold first-letter  tracking-wider">
                R1400
              </span>
            </div>
          </div>
        </div>
      </div>

      {/**Container */}
      {/* <div className='w-full mx-auto flex  p-4 h-[700px]  bg-cover' style={{backgroundImage: `url(${register})`}}>
            <div className='pb-5 py-20'>
               <p className=' text-4xl font-bold  mx-auto text-blue-950'>Member Registration</p>
            </div>
         
           </div> */}

      <div
        name="ContactUs"
        className="w-full bg-black flex justify-center items-center p-4"
        style={{ backgroundImage: `url(${About})` }}
      >
        {/*the form starts here  */}
        <form
          ref={form}
          method="POST"
          action=""
          onSubmit={sendEmail}
          className=" text-white flex flex-col max-w-[600px]  pb-5 backdrop-blur-2xl "
        >
          <div className="pb-8 ">
            <p className="text-4xl font-bold inline border-b-4 border-blue-500 text-white">
              Registration Form
            </p>
          </div>
          <p>
            Title:
            <label className="px-5">
              <input
                className="my-1 px-2 opacity-75 hover:opacity-100"
                type="radio"
                name="title"
                value="Mr"
                onChange={onChangeHandler}
                checked={formData.title === "Mr"}
              />
              Mr
            </label>
            <label className="px-5">
              <input
                className="my-1 px-2 opacity-75 hover:opacity-100"
                type="radio"
                name="title"
                value="Mrs"
                onChange={onChangeHandler}
                checked={formData.title === "Mrs"}
              />
              Mrs
            </label>
            <label className="px-5">
              <input
                className="my-1 px-2 opacity-75 hover:opacity-100"
                type="radio"
                name="title"
                value="Miss"
                onChange={onChangeHandler}
                checked={formData.title === "Miss"}
              />
              Miss
            </label>
            <label className="px-5">
              <input
                className="my-1 px-2 opacity-75 hover:opacity-100"
                type="radio"
                name="title"
                value="Master"
                onChange={onChangeHandler}
                checked={formData.title === "Master"}
              />
              Master
            </label>
          </p>
          <input
            className="bg-white text-[#001ea1] my-1 p-2 opacity-75 hover:opacity-100"
            onChange={onChangeHandler}
            placeholder="Surname"
            name="surname"
            required
          />
          <input
            className="bg-white text-[#001ea1] my-1 p-2 opacity-75 hover:opacity-100"
            onChange={onChangeHandler}
            placeholder="Name"
            name="name"
            required
          />
          <input
            className="my-1 p-2 text-[#001ea1] opacity-75 hover:opacity-100"
            type="date"
            onChange={onChangeHandler}
            placeholder="Date of Birth"
            name="dateOfBirth"
            required
          />
          <input
            className="my-1 p-2 text-[#001ea1] opacity-75 hover:opacity-100"
            type="tel"
            onChange={onChangeHandler}
            placeholder="ID Number/Passport Number"
            name="identityNumber"
            required
          />
          <input
            className="my-1 p-2 text-[#001ea1] opacity-75 hover:opacity-100"
            type="text"
            onChange={onChangeHandler}
            placeholder="address"
            name="address"
            required
          />
          <input
            className="my-1 p-2 text-[#001ea1] opacity-75 hover:opacity-100"
            type="email"
            onChange={onChangeHandler}
            placeholder="email"
            name="email"
            required
          />
          <p>
            {" "}
            Gender
            <label className="px-5">
              <input
                className="my-1 px-2 opacity-75 hover:opacity-100"
                type="radio"
                value="male"
                name="gender"
                onChange={onChangeHandler}
                checked={formData.gender === "male"}
              />
              Male
            </label>
            <label className="px-5">
              <input
                className="my-1 px-2 opacity-75 hover:opacity-100"
                type="radio"
                name="gender"
                value="female"
                onChange={onChangeHandler}
                checked={formData.gender === "female"}
              />
              Female
            </label>
            <label className="px-5">
              <input
                className="my-1 px-2 opacity-75 hover:opacity-100"
                type="radio"
                name="gender"
                value="others"
                onChange={onChangeHandler}
                checked={formData.gender === "others"}
              />
              Others
            </label>
          </p>

          <input
            className="my-1 p-2 text-[#001ea1] opacity-75 hover:opacity-100"
            type="text"
            placeholder="Contact Number"
            name="contactNumber"
            onChange={onChangeHandler}
            required
          />

          <input
            className="my-1 p-2 text-[#001ea1] opacity-75 hover:opacity-100"
            type="text"
            placeholder="Occupation"
            name="occupation"
            onChange={onChangeHandler}
          />
          <p className="font-bold ">
            {" "}
            Personal Coaching:
            <label className="px-5">
              <input
                className="my-1 px-2 opacity-75 hover:opacity-100"
                type="radio"
                name="personalCoaching"
                value="Yes"
                onChange={onChangeHandler}
                checked={formData.personalCoaching === "Yes"}
              />
              Yes
            </label>
            <label className="px-5">
              <input
                className="my-1 px-2 opacity-75 hover:opacity-100"
                type="radio"
                name="personalCoaching"
                value="No"
                onChange={onChangeHandler}
                checked={formData.personalCoaching === "No"}
              />
              No
            </label>
            <label className="px-5">
              <input
                className="my-1 px-2 opacity-75 hover:opacity-100"
                type="radio"
                name="personalCoaching"
                value="At a later Stage"
                onChange={onChangeHandler}
                checked={formData.personalCoaching === "at a later Stage"}
              />
              At a later stage
            </label>
          </p>
          <input
            className="my-1 p-2 text-[#001ea1] opacity-75hover:opacity-100"
            type="text"
            placeholder="License Number"
            name="licenseNumber"
            onChange={onChangeHandler}
            required
          />
          <h2> Interests:</h2>
          <div classname="grid text-white  grid-cols-1">
            <div>
              <label className="px-5 text-white ">
                <input
                  className="my-1 px-2 opacity-75 hover:opacity-100"
                  type="checkbox"
                  name="interest"
                  value="roadRunning"
                  onChange={onChangeHandler}
                  checked={formData.interest.indexOf("roadRunning") !== -1}
                />
                Road Running
              </label>
            </div>
            <div>
              <label className="px-5 text-white">
                <input
                  className="my-1 px-2 opacity-75 hover:opacity-100"
                  type="checkbox"
                  name="interest"
                  value="crossFit"
                  onChange={onChangeHandler}
                  checked={formData.interest.indexOf("crossFit") !== -1}
                />
                Cross Fit
              </label>
            </div>
            <div>
              <label className="px-5 text-white">
                <input
                  className="my-1 px-2 opacity-75 hover:opacity-100"
                  type="checkbox"
                  name="interest"
                  value="cycling"
                  onChange={onChangeHandler}
                  checked={formData.interest.indexOf("cycling") !== -1}
                />
                Cycling
              </label>
            </div>
            <div>
              <label className="px-5 text-white">
                <input
                  className="my-1 px-2 opacity-75 hover:opacity-100"
                  type="checkbox"
                  name="interest"
                  value="hiking"
                  onChange={onChangeHandler}
                  checked={formData.interest.indexOf("hiking") !== -1}
                />
                Hiking
              </label>
            </div>
            <div>
              <label className="px-5 text-white">
                <input
                  className="my-1 px-2 opacity-75 hover:opacity-100"
                  type="checkbox"
                  name="interest"
                  value="swimming"
                  onChange={onChangeHandler}
                  checked={formData.interest.indexOf("swimming") !== -1}
                />
                Swimming
              </label>
            </div>
            <div>
              <label className="px-5 text-white">
                <input
                  className="my-1 px-2 opacity-75 hover:opacity-100"
                  type="checkbox"
                  name="interest"
                  value="trailRunning"
                  onChange={onChangeHandler}
                  checked={formData.interest.indexOf("trailRunning") !== -1}
                />
                Trail Running
              </label>
            </div>
            <div>
              <label className="px-5 text-white">
                <input
                  className="my-1 px-2 opacity-75 hover:opacity-100"
                  type="checkbox"
                  name="interest"
                  value="walking"
                  onChange={onChangeHandler}
                  checked={formData.interest.indexOf("walking") !== -1}
                />
                Walking
              </label>
            </div>
            <div>
              <label className="px-5 text-white">
                <input
                  className="my-1 px-2 opacity-75 hover:opacity-100"
                  type="checkbox"
                  name="interest"
                  value="yoga"
                  onChange={onChangeHandler}
                  checked={formData.interest.indexOf("yoga") !== -1}
                />
                Yoga
              </label>
            </div>
            <div>
              <label className="px-5 text-white">
                <input
                  className="my-1 px-2 opacity-75 hover:opacity-100"
                  type="checkbox"
                  name="interest"
                  value="other"
                  onChange={onChangeHandler}
                  checked={formData.interest.indexOf("other") !== -1}
                />
                Other
              </label>
            </div>
          </div>
          <input
            className="bg-white my-1 p-2 text-[#001ea1] opacity-75 hover:opacity-100"
            type="text"
            onChange={onChangeHandler}
            placeholder="School"
            name="school"
          />
          <input
            className="bg-white my-1 p-2 text-[#001ea1] opacity-75 hover:opacity-100"
            type="tel"
            onChange={onChangeHandler}
            placeholder="Grade"
            name="grade"
          />
          <input
            className="bg-white my-1 p-2 text-[#001ea1]  opacity-75 hover:opacity-100"
            type="text"
            onChange={onChangeHandler}
            placeholder="Next of Kin"
            name="nextOfKin"
            required
          />
          <input
            className="bg-white my-1 p-2 text-[#001ea1] opacity-75 hover:opacity-100"
            type="tel"
            onChange={onChangeHandler}
            placeholder="Emergency Contact"
            name="emergencyContact"
            required
          />
          <input
            className="bg-white my-1 p-2 text-[#001ea1] opacity-75 hover:opacity-100"
            type="text"
            onChange={onChangeHandler}
            placeholder="Medical Aid Scheme"
            name="medicalAidScheme"
          />
          <input
            className="bg-white my-1 p-2 text-[#001ea1] opacity-75 hover:opacity-100"
            type="tel"
            onChange={onChangeHandler}
            placeholder="Medical Aid Number"
            name="medicalAidNumber"
          />
          <div className=" text-white grid grid-cols-1 p-5 w-full">
            {" "}
            Membership Fees:
            <div>
              <label className="px-5 text-white">
                <input
                  className="my-1 px-2 opacity-75 hover:opacity-100"
                  type="radio"
                  name="membershipFees"
                  value="junior"
                  onChange={onChangeHandler}
                  checked={formData.membershipFees === "junior"}
                />
                Junior-19 and younger -R470{" "}
              </label>
            </div>
            <div>
              <label className="px-5">
                <input
                  className="my-1 px-2 opacity-75 hover:opacity-100"
                  type="radio"
                  name="membershipFees"
                  value="senior"
                  onChange={onChangeHandler}
                  checked={formData.membershipFees === "senior"}
                />
                Senior:20-39 -R800{" "}
              </label>
            </div>
            <div>
              <label className="px-5">
                <input
                  className="my-1 px-2 opacity-75 hover:opacity-100"
                  type="radio"
                  name="membershipFees"
                  value="veteran"
                  onChange={onChangeHandler}
                  checked={formData.membershipFees === "veteran"}
                />
                Veteran:40-49 -R800
              </label>
            </div>
            <div>
              <label className="px-5">
                <input
                  className="my-1 px-2 opacity-75 hover:opacity-100"
                  type="radio"
                  name="membershipFees"
                  value="master"
                  onChange={onChangeHandler}
                  checked={formData.membershipFees === "master"}
                />
                Master:50-59 -R800
              </label>
            </div>
            <div>
              <label className="px-5">
                <input
                  className="my-1 px-2 opacity-75 hover:opacity-100"
                  type="radio"
                  name="membershipFees"
                  value="grandMaster"
                  onChange={onChangeHandler}
                  checked={formData.membershipFees === "grandMaster"}
                />
                Grand Master:60+ -R470
              </label>
            </div>
            <div>
              <label className="px-5">
                <input
                  className="my-1 px-2 opacity-75 hover:opacity-100"
                  type="radio"
                  name="membershipFees"
                  value="couples"
                  onChange={onChangeHandler}
                  checked={formData.membershipFees === "couples"}
                />
                Couples(2 Members): -R1400
              </label>
            </div>
            <div className="">
              <label className="px-5 justify-center">
                <input
                  className="my-1 px-2 opacity-75 hover:opacity-100"
                  type="radio"
                  name="membershipFees"
                  value="family"
                  onChange={onChangeHandler}
                  checked={formData.membershipFees === "family"}
                />
                Family:25% discount for 3 or more{" "}
              </label>
              <p className="pl-8">
                family memebers if they join at the same time
              </p>
            </div>
          </div>

          <button
            className="text-white border-2  hover:bg-blue-700 hover:border-blue-600   mx-auto flex items-center px-1 opacity-75 hover:opacity-100 ver:font-weight:bold hover:scale-110 duration-200 hover:font-bold"
            type="submit"
            onSubmit={sendEmail}
          >
            Send
          </button>
        </form>
      </div>
    </div>
  );
};

export default MemberRegistration;
